import { all, call, put, takeLatest } from 'redux-saga/effects'
import AuthAction, { AuthTypes } from 'Redux/AuthRedux'
import { authDataKeys } from 'Services/Api'

export function* sendEmail(api, action) {
  const resp = yield call(api.sendCodeEmail, action.params)
  if (resp.ok) {
    action.callback(resp, null)
  } else {
    let errText = 'Invalid username or password. Please retry'
    action.callback(null, errText)
  }
}

export function* verifyCode(api, action) {
  const resp = yield call(api.verifyCode, action.params)
  if (resp.ok) {
    action.callback(resp, null)
  } else {
    let errText = 'There was an error creating your account. Please try again'
    if (resp.data && resp.data.errors === 'invalid_code') {
      errText =
        'The code entered is not correct or has already been redeemed. Please enter the correct code or contact {{store_owner}}'
    }
    action.callback(null, errText)
  }
}

export function* me(api, action) {
  const resp = yield call(api.me, { token: action.token })
  if (resp.ok) {
    action.callback(resp)
  }
}

export function* onLogout(api, action) {
  const resp = yield call(api.onLogout)
  if (resp.ok) {
    action.callback(resp)
  }
}

export default function* appointmentSagas(api) {
  yield all([
    takeLatest(AuthTypes.SEND_EMAIL_REQUEST, sendEmail, api),
    takeLatest(AuthTypes.VERIFY_CODE_REQUEST, verifyCode, api),
    takeLatest(AuthTypes.ME, me, api),
    takeLatest(AuthTypes.LOGOUT, onLogout, api),
  ])
}
